import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[filterContainerDisplay]',
    standalone: false
})
export class FilterContainerDisplayDirective {

  @HostBinding('style.display') display = ''

  @Input() set filterDisplay(shouldDisplay: boolean) {
    this.display = shouldDisplay ? '' : 'none'
  }
}
